export function logError(error, errorMessage, metadata = {}) {
	if(window.bugsnagClient) {
		console.error(errorMessage, error, metadata);
		window.bugsnagClient.notify(error, (event) => {
			event.errors[0].errorMessage = event.groupingHash = errorMessage;
	
			for(let name in metadata) {
				event.addMetadata(name, metadata[name]);
			}
		});
	} else if(window.$ && window.$.fireErrorReport) {
		metadata.exception = error;
		window.$.fireErrorReport(null, errorMessage, errorMessage, metadata);
	} else {
		console.error(errorMessage, error, metadata);
	}
}